/* Scoop fresh: add to cart straight from product cards. */
(function () {
  function add(btn) {
    var box = btn.closest('[data-scard]');
    var idEl = box && box.querySelector('[data-scard-id]');
    if (!idEl) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    var label = btn.textContent;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding...';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-busy');
      if (res.status || res.description) { btn.textContent = res.description || 'Could not add'; setTimeout(function () { btn.textContent = label; }, 2500); return; }
      btn.classList.add('is-done');
      btn.textContent = 'Added';
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
      var item = res.items && res.items[0];
      if (cart && cart.renderContents && item) {
        cart.renderContents(Object.assign({}, item, { sections: res.sections }));
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () {
      btn.classList.remove('is-busy');
      btn.textContent = label;
    });
  }
  (function placeAward() {
    var b = document.querySelector('.saward--pdp');
    var host = document.querySelector('.product__media-wrapper');
    if (b && host) { host.appendChild(b); b.classList.add('is-placed'); }
  })();
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-scard-id]');
    if (!sel) return;
    var box = sel.closest('[data-scard]');
    var pr = box && box.querySelector('[data-scard-price]');
    var o = sel.options[sel.selectedIndex];
    if (pr && o && o.dataset.price) pr.textContent = o.dataset.price;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-scard-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    add(btn);
  }, true);
})();
